/* eslint-disable */

window.DeferredJS = {
	list: [],
	checker: null,
	init: function(context) {
		this.context = context;
	},
	addBundles: function(bundles) {
		clearTimeout(this.checker);
		if (bundles) {
			this.list = this.list.concat(bundles);
		}

		this.check();
	},
	isFunction: function(obj) {
		/* [[[ ripped from _.isFunction ]]] */
		return !!(obj && obj.constructor && obj.call && obj.apply);
	},
	check: function() {
		/* [[[ do nothing if there is nothing to do ]]] */
		if (!this.list.length) {
			return;
		}
		this.checkList();
		this.recheck();
	},
	checkList: function() {
		let i,
			j,
			length,
			bundle,
			hierarchy,
			params,
			func,
			funcScope,
			callback;

		/* [[[ Loop through BACKWARDS so we can slice as we please ]]] */
		for (i = this.list.length - 1; i >= 0; i--) {
			bundle = this.list[i];
			hierarchy = bundle.hierarchy;
			params = bundle.params;
			callback = bundle.callback;

			/* [[[ start at window ]]] */
			func = funcScope = this.context;

			/* [[[ check that everthing is okay ]]] */
			for (j = 0, length = hierarchy.length; j < length; j++) {
				func = func[hierarchy[j]];

				/* [[[ if we are not ready yet, GTFO ]]] */
				if (typeof (func) === "undefined") {
					break;
				}

				/* [[[ if we have reached the end, go for it! ]]] */
				if (this.isFunction(func)) {
					if (params) {
						/* [[[ if there are params, run the function ]]] */
						func.apply(funcScope, params);
					}

					if (callback) {
						/* [[[ If there's a callback, run that. ]]] */
						callback(func);
					}

					/* [[[ kick this off the list ]]] */
					this.list.splice(i, 1);
				}

				funcScope = func;
			}
		}
	},
	recheck: function() {
		/* [[[ If we still got shit to do, try again later ]]] */
		/* [[[ Use _this, because we cannot be sure prototype is here ]]] */
		this.checker = setTimeout((function(_this) {
			return function() {
				_this.check();
			};
		}(this)), 10);
	},
};

if (typeof window !== "undefined") {
	window.DeferredJS.init(window);
}



// WEBPACK FOOTER //
// ./src/shared/modules/deferredjs/index.js